import React from "react";
export default function formErrorHelper(errors) {
  return function formError(name) {
    const error = errors.find((err) => err.key === name);
    if (error) {
      return (<p className="bp3-text-small" style={{ color: "red" }}>
        {error.message}
      </p>);
    }
  };
}
